// @core/api/endpoints/tenant/list_tenant_migrations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTenantMigrationsResponse,
} from '../../../types/tenant';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/tenant';

/**
 * List tenant migrations
 * Returns migration requests across tenants on the platform, optionally filtered by status. Used by platform admins to review pending and historical migrations.
 */
export async function ListTenantMigrations(
  params?: PaginatedRequest & {
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListTenantMigrationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/migrations`;
  const requestOptions = options;
  return client.get<ListTenantMigrationsResponse>(requestPath, { ...requestOptions, params });
}
